module.exports = __webpack_public_path__ + "static/media/img-7.fc96d159.jpg";